module.exports = __webpack_public_path__ + "img/bestseller.696c0033.png";